import algos from "string-comparison";
import * as ContactConstants from "./constants";
export { ContactConstants };
export const getLabelName = (item) => {
    if (!item) {
        return "";
    }
    if (item.type === "individual") {
        return `${item.individualFirstName ?? ""} ${item.individualLastName ?? ""}`;
    }
    return `${item.organizationName ?? ""}`;
};
export const getContactVatPrint = (legal = {}) => {
    if (!legal?.vat) {
        return "";
    }
    const { vat } = legal;
    return `${vat.countryCode}${vat.vatNumber}`;
};
export const findContact = (contacts, terms) => {
    const { name, vatId, IBANs } = terms;
    const nameLC = name ? name.toLowerCase() : "";
    for (const c of contacts) {
        if (IBANs?.length && c.banks?.length) {
            for (const IBAN of IBANs) {
                if (c.banks.some(b => b?.IBAN === IBAN)) {
                    return c;
                }
            }
        }
        const labelName = getLabelName(c).toLowerCase();
        if (nameLC) {
            if (nameLC === labelName) {
                return c;
            }
            if (algos.levenshtein.similarity(nameLC, labelName) > 0.91) {
                return c;
            }
            if ((c.banks ?? []).some(b => b?.accountHolder &&
                (b.accountHolder === nameLC || algos.levenshtein.similarity(nameLC, b.accountHolder) > 0.91))) {
                return c;
            }
        }
        if (vatId) {
            if (vatId === getContactVatPrint(c.legalInfo)) {
                return c;
            }
            // in case AI was confused with steuernummer
            if (vatId === c.legalInfo?.tax?.stnr) {
                return c;
            }
        }
    }
};
//# sourceMappingURL=index.js.map